import { Link } from 'gatsby';
import ProductsArticles from 'components/Indoor_Cameras/IntroIndoorCams';
import NavButtons from 'components/Products/NavButtons';
import CompareIndoor from 'components/Products/Compare/CompareIndoorFlyout';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  ProductsArticles,
  NavButtons,
  CompareIndoor,
  BreadCrumbs,
  SEOHelmet,
  React
};